/* eslint-disable*/
import React, { useState } from 'react';
import { Grid, Button, Typography, Box, Paper } from '@material-ui/core';
import Carousel from 'react-material-ui-carousel';
import { ReactComponent as EditPenIconGreen } from '../../../assets/images/EditPenGreen.svg';
import { backendLocalUrl, FROM } from '../../../constants/globalConstants';
import ShowMoreText from 'react-show-more-text';
import useCommunityList from '../../../hooks/useCommunityList';

const AmenityBox = ({ amenity, isAccessible, publicView, onAmenityUpdate, editFrom }) => {
  const executeOnClick = (isExpanded) => {};
  const { toggleAmenityFeatured } = useCommunityList();
  const [togglingFeatured, setTogglingFeatured] = useState(false);

  // Handle toggle featured status
  const handleToggleFeatured = async (event) => {
    // Stop event propagation to prevent any parent click handlers
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!amenity || !amenity.id) {
      console.error('Invalid amenity data');
      return;
    }

    setTogglingFeatured(true);
    try {
      console.log('Toggling featured status:', {
        amenityId: amenity.id,
        currentValue: amenity.featuredAmenity,
        newValue: false,
      });

      const result = await toggleAmenityFeatured({
        amenityId: amenity.id,
        featuredAmenity: false,
      });

      console.log('Toggle result:', result);

      // Only trigger update if API call was successful
      if (result?.status === true) {
        // Notify parent component to refresh the list
        if (onAmenityUpdate) {
          await onAmenityUpdate();
        }
      } else {
        console.error('Failed to toggle featured status:', result?.message);
      }
    } catch (error) {
      console.error('Error toggling featured status:', error);
    } finally {
      setTogglingFeatured(false);
    }
  };

  return (
    /*  <Grid item xs={12} sm={4}>
     */
    <Box className="AmenitiesSliderBox">
      <Box className="SliderContainer">
        {isAccessible && !publicView && (
          <Button
            className="EditCommonButtonFloatSecond"
            href={`/#/app/community-details-edit-add-new-amenity/${
              editFrom || FROM.COMMUNITY_DETAILS
            }/${amenity?.communityId}/${amenity?.id}`}
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<EditPenIconGreen />}
          >
            Edit
          </Button>
        )}
        <Carousel
          navButtonsAlwaysVisible={true}
          autoPlay={false}
          className="SliderCarousel"
          navButtonsProps={{
            style: {
              backgroundColor: '#000',
              padding: '0',
            },
          }}
          indicatorIconButtonProps={{
            style: {
              padding: '0px',
              color: 'rgba(255, 255, 255, 0.6)',
            },
          }}
          activeIndicatorIconButtonProps={{
            style: {
              padding: '0px',
              color: 'rgba(255, 255, 255, 1)',
            },
          }}
          indicatorContainerProps={{
            style: {
              marginTop: '0px',
              position: 'absolute',
              bottom: '5px',
            },
          }}
        >
          {amenity.amenityGallery.length > 0 ? (
            amenity.amenityGallery.map((image, i) => (
              <Paper key={i}>
                <Box className="CardBannerBox">
                  <img
                    src={
                      window.location.hostname === 'localhost'
                        ? `${backendLocalUrl}/${image.image}`
                        : `api/${image.image}`
                    }
                  />
                </Box>
              </Paper>
            ))
          ) : (
            <Paper key="amenity-no-image">
              <Box className="CardBannerBox">
                <img
                  src={
                    window.location.hostname === 'localhost'
                      ? `${backendLocalUrl}/assets/images/NoImage.png`
                      : `api/assets/images/NoImage.png`
                  }
                  alt="No Image"
                />
              </Box>
            </Paper>
          )}
        </Carousel>
      </Box>
      <Box className="SliderInfoContent">
        <Typography variant="h6" className="AmenitiesCategory">
          {amenity?.amenityCategory?.amenityCategoryName}
        </Typography>
        <Typography variant="h3" className="AmenitiesName">
          {amenity?.amenityName}
        </Typography>
        <Box className="AmenitiesAddess">
          <Typography variant="caption" className="AmenitiesInsightLabel">
            Address
          </Typography>
          <Typography variant="body2" className="AmenitiesInsight">
            {amenity?.amenityAddress || '-'}
          </Typography>
        </Box>
        <Box className="AmenitiesText">
          <Typography variant="caption" className="AmenitiesInsightLabel">
            Description
          </Typography>
          <Typography variant="body2" className="AmenitiesInsight">
            <ShowMoreText
              lines={3}
              more="Show More"
              less="Show Less"
              className="ReadMoreBox NoArrow"
              anchorClass="show-more-less-clickable"
              onClick={executeOnClick}
              expanded={false}
              truncatedEndingComponent={'... '}
            >
              {amenity?.amenityDesc || '-'}
            </ShowMoreText>
          </Typography>
        </Box>
        {isAccessible && !publicView && (
          <Button
            className="SelectAmenityButton"
            variant="outlined"
            color={amenity?.featuredAmenity ? 'secondary' : 'primary'}
            fullWidth
            disabled={togglingFeatured}
            {...(amenity?.featuredAmenity
              ? { onClick: handleToggleFeatured }
              : {
                  href: `/#/app/community-details-edit-add-new-amenity/${
                    editFrom || FROM.AMENITIES_LiST
                  }/${amenity?.communityId}/${amenity?.id}`,
                })}
          >
            {togglingFeatured
              ? 'Updating...'
              : amenity?.featuredAmenity
              ? 'Remove From Featured'
              : 'Select'}
          </Button>
        )}
      </Box>
    </Box>
    /*  </Grid> */
  );
};

export default AmenityBox;
